import {
    collection,
    doc,
    query,
    serverTimestamp,
    setDoc,
    where,
} from "firebase/firestore";
import { nanoid } from "nanoid";
import { useFirestore, useFirestoreCollectionData } from "reactfire";
import { Grid } from "../game/types/grid";
import { MapType } from "../game/types/project";

const getDefaultGrid = () => {
    const WIDTH = 10;
    const HEIGHT = 10;
    let arr = [];
    for (var row = 0; row < HEIGHT; row++) {
        let r = [];
        for (var column = 0; column < WIDTH; column++) {
            r.push({
                x: column,
                y: row,
                src: "",
                properties: [],
            });
        }
        arr.push(r);
    }

    return arr as Grid;
};

type AllProjectReturn = {
    data: MapType[];
    status: "loading" | "error" | "success";
    addMap: (callback: (id: string) => void) => void;
};

export default function useAllMaps({
    projectId,
}: {
    projectId: string;
}): AllProjectReturn {
    const DB = useFirestore();
    const COLLECTION = "maps";

    const allMaps = collection(DB, COLLECTION);
    const allProjectMaps = query(allMaps, where("projectId", "==", projectId));

    const { status, data } = useFirestoreCollectionData(allProjectMaps);

    const addMap = async (callback: (id: string) => void) => {
        const id = nanoid();
        const config: MapType = {
            id,
            grid: JSON.stringify(getDefaultGrid()),
            lastUpdated: serverTimestamp(),
            name: "Default map",
            projectId,
            type: 'map'
        };

        callback(id);

        await setDoc(doc(DB, COLLECTION, id), config);
    };

    return {
        data: (data || []) as MapType[],
        status,
        addMap,
    };
}
